import React from 'react';
import './Footer.css';
import { FaFacebookF, FaInstagram } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="site-footer">
      <div className="footer-content">
        <div className="footer-logo">
          <img src="/images/vilasol_logo_clean_nobrown.svg" alt="Vila Sol Caffe Logo" />
        </div>

        <div className="footer-links">
          <a href="#about">{t('nav.about')}</a>
          <a href="#menu">{t('nav.menu')}</a>
          <a href="#gallery">{t('nav.gallery')}</a>
          <a href="#contact">{t('nav.contact')}</a>
        </div>

        <div className="footer-socials">
          <a href="https://www.facebook.com/p/Vila-Sol-Caff%C3%A9-100032786960522/" target="_blank" rel="noreferrer" aria-label="Facebook">
            <FaFacebookF />
          </a>
          <a href="https://www.instagram.com/vilasolcaffe/?hl=en" target="_blank" rel="noreferrer" aria-label="Instagram">
            <FaInstagram />
          </a>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Vila Sol Caffe. {t('footer.rights')}</p>
      </div>
    </footer>
  );
};

export default Footer;
